"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUMPRODUCT = void 0;
// Note: if enabling SIMD instructions in the future, this will benefit
exports.SUMPRODUCT = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        const arrays = [];
        for (const input of inputs) {
            if (Array.isArray(input)) {
                // Validate array length, then push
                // Validate type of each element at time of calculation (no need to perform extra work here)
                if (arrays.length === 0 || input.length === arrays[0].length) {
                    // First array input, no validation
                    // Any others should have the same array length
                    arrays.push(input);
                }
                else {
                    return {
                        error: 'Array inputs for SUMPRODUCT must have the same length',
                    };
                }
            }
            else {
                return {
                    error: 'Inputs for SUMPRODUCT must be arrays of numbers',
                };
            }
        }
        // Using for loops instead of collection methods in order to allow for early exit if required
        let sum = 0;
        // eslint-disable-next-line no-restricted-syntax
        for (let rowIdx = 0; rowIdx < arrays[0].length; rowIdx += 1) {
            let rowProduct = 1;
            // eslint-disable-next-line no-restricted-syntax
            for (let arrayIdx = 0; arrayIdx < arrays.length; arrayIdx += 1) {
                const arrayElement = arrays[arrayIdx][rowIdx];
                if (typeof arrayElement !== 'number') {
                    return { error: 'Inputs for SUMPRODUCT must be arrays of numbers' };
                }
                rowProduct *= arrayElement;
            }
            sum += rowProduct;
        }
        return { error: null, result: sum };
    },
};
//# sourceMappingURL=sumproduct.js.map